const PROPERTY_REGISTRY = {
  groups: [
    { id: 'mechanical', label: 'Mechanical' },
    { id: 'thermal', label: 'Thermal' },
    { id: 'electronic', label: 'Electronic' },
    { id: 'chemical', label: 'Chemical' },
    { id: 'molecular', label: 'Molecular' },
  ],
  properties: [
    {
      id: 'band_gap',
      label: 'Band gap',
      group: 'electronic',
      default_unit: 'eV',
      modes: ['maximize', 'minimize', 'range', '>=', '<=', '='],
      better_direction: 'range',
      feasible_range: [0, 10],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {
        mattergen: { archetype: 'dft_band_gap', property_key: 'dft_band_gap' },
      },
      screeners: {},
    },
    {
      id: 'conductivity',
      label: 'Electrical conductivity',
      group: 'electronic',
      default_unit: 'S/m',
      modes: ['maximize', 'minimize', 'range', '>=', '<=', '='],
      better_direction: null,
      feasible_range: [1e-12, 1e8],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'bulk_modulus',
      label: 'Bulk modulus',
      group: 'mechanical',
      default_unit: 'GPa',
      modes: ['maximize', 'minimize', 'range', '>=', '<=', '='],
      better_direction: 'higher',
      feasible_range: [0, 500],
      default_importance: 'high',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {
        mattergen: { archetype: 'ml_bulk_modulus', property_key: 'ml_bulk_modulus' },
      },
      screeners: {
        inorganic_surrogate: { service: 'm3gnet-service', field: 'bulk_modulus_GPa' },
      },
    },
    {
      id: 'tensile_strength',
      label: 'Tensile strength',
      group: 'mechanical',
      default_unit: 'MPa',
      modes: ['maximize', 'minimize', 'range', '>=', '<=', '='],
      better_direction: 'higher',
      feasible_range: [0, 3000],
      default_importance: 'high',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'thermal_conductivity',
      label: 'Thermal conductivity',
      group: 'thermal',
      default_unit: 'W/mK',
      modes: ['maximize', 'minimize', 'range', '>=', '<=', '='],
      better_direction: null,
      feasible_range: [0, 1000],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'thermal_expansion',
      label: 'Thermal expansion coefficient',
      group: 'thermal',
      default_unit: '1/K',
      modes: ['maximize', 'minimize', 'range', '>=', '<=', '='],
      better_direction: 'lower',
      feasible_range: [1e-7, 5e-4],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'energy_above_hull',
      label: 'Energy above hull',
      group: 'chemical',
      default_unit: 'eV/atom',
      modes: ['minimize', 'range', '<=', '='],
      better_direction: 'lower',
      feasible_range: [0, 1.0],
      default_importance: 'critical',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {
        mattergen: { archetype: 'chemical_system_energy_above_hull', property_key: 'energy_above_hull', requires: ['chemical_system'] },
      },
      screeners: {},
    },
    {
      id: 'n_atoms',
      label: 'Atom count',
      group: 'chemical',
      default_unit: '',
      modes: ['range', '>=', '<=', '='],
      better_direction: null,
      feasible_range: [1, 500],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'density_est',
      label: 'Estimated density',
      group: 'mechanical',
      default_unit: 'g/cm³',
      modes: ['maximize', 'minimize', 'range', '>=', '<=', '='],
      better_direction: null,
      feasible_range: [0.5, 25],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'volume_per_atom',
      label: 'Volume per atom',
      group: 'chemical',
      default_unit: 'ų',
      modes: ['minimize', 'range', '>=', '<=', '='],
      better_direction: 'lower',
      feasible_range: [5, 100],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'min_interatomic_distance',
      label: 'Min interatomic distance',
      group: 'chemical',
      default_unit: 'Å',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [0.5, 5.0],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'mean_atomic_number',
      label: 'Mean atomic number',
      group: 'chemical',
      default_unit: '',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [1, 94],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'mean_electronegativity',
      label: 'Mean electronegativity',
      group: 'electronic',
      default_unit: '',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [0.5, 4.0],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'electronegativity_std',
      label: 'Electronegativity spread',
      group: 'electronic',
      default_unit: '',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [0, 2.0],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'valence_electron_density',
      label: 'Valence electron density',
      group: 'electronic',
      default_unit: 'e⁻/ų',
      modes: ['maximize', 'minimize', 'range', '>=', '<='],
      better_direction: null,
      feasible_range: [0, 2.0],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'packing_fraction_est',
      label: 'Packing fraction estimate',
      group: 'mechanical',
      default_unit: '',
      modes: ['maximize', 'minimize', 'range', '>=', '<='],
      better_direction: 'higher',
      feasible_range: [0.1, 1.0],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'stability_window',
      label: 'Electrochemical stability window',
      group: 'chemical',
      default_unit: 'V',
      modes: ['maximize', 'range', '>=', '<=', '='],
      better_direction: 'higher',
      feasible_range: [0, 10],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    // ── Molecular properties (FM4M / RDKit) ─────────────────────────────────
    {
      id: 'molecular_weight',
      label: 'Molecular Weight',
      group: 'molecular',
      domain: 'molecular',
      default_unit: 'g/mol',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [0, 1000],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'logP',
      label: 'logP (Crippen)',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [-5, 10],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'tpsa',
      label: 'TPSA',
      group: 'molecular',
      domain: 'molecular',
      default_unit: 'Å²',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [0, 200],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'hbd',
      label: 'H-Bond Donors',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['range', '<='],
      better_direction: 'lower',
      feasible_range: [0, 20],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'hba',
      label: 'H-Bond Acceptors',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['range', '<='],
      better_direction: 'lower',
      feasible_range: [0, 20],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'qed',
      label: 'QED (Drug-likeness)',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['maximize', 'range', '>='],
      better_direction: 'higher',
      feasible_range: [0, 1],
      default_importance: 'high',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'sa_score',
      label: 'Synth. Accessibility',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['minimize', 'range', '<='],
      better_direction: 'lower',
      feasible_range: [1, 10],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'rotatable_bonds',
      label: 'Rotatable Bonds',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['range', '<='],
      better_direction: null,
      feasible_range: [0, 30],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'aromatic_rings',
      label: 'Aromatic Rings',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [0, 10],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'fraction_sp3',
      label: 'Fraction Csp³',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['range', '>=', '<='],
      better_direction: null,
      feasible_range: [0, 1],
      default_importance: 'low',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
    {
      id: 'ro5_violations',
      label: 'RO5 Violations',
      group: 'molecular',
      domain: 'molecular',
      default_unit: '',
      modes: ['minimize', 'range', '<='],
      better_direction: 'lower',
      feasible_range: [0, 4],
      default_importance: 'medium',
      can_optimize: true,
      can_filter: true,
      surrogate_required: false,
      generators: {},
      screeners: {},
    },
  ],
};

function findPropertyById(id) {
  if (!id) return null;
  return PROPERTY_REGISTRY.properties.find((p) => p.id === id);
}

function objectiveToTarget(obj) {
  const p = findPropertyById(obj?.property);
  if (!p) return null;
  const type = p.group || 'other';
  const unit = p.default_unit || null;
  const priority = obj?.priority || 'prefer';

  const m = String(obj?.mode || '').toLowerCase();
  let constraint = null;
  let value = null;
  if (m === 'maximize' || m === 'minimize') {
    constraint = m;
    value = Number.isFinite(obj?.target_value) || Array.isArray(obj?.target_value) ? obj.target_value : null;
  } else if (m === 'range') {
    constraint = 'range';
    const v = Array.isArray(obj?.target_value) ? obj.target_value : [];
    value = v.length === 2 ? [Number(v[0]), Number(v[1])] : null;
  } else if (m === '>=') {
    constraint = '>=';
    value = Number(obj?.target_value);
  } else if (m === '<=') {
    constraint = '<=';
    value = Number(obj?.target_value);
  } else if (m === '=' || m === 'equals' || m === 'target') {
    constraint = '=';
    value = Number(obj?.target_value);
  }
  if (Array.isArray(value)) {
    const a = Number(value[0]);
    const b = Number(value[1]);
    value = [Number.isFinite(a) ? a : null, Number.isFinite(b) ? b : null];
  } else if (typeof value === 'number' && !Number.isFinite(value)) {
    value = null;
  }

  return {
    name: p.id,
    type,
    constraint,
    value,
    unit,
    priority,
    source: 'inferred',
  };
}

export { PROPERTY_REGISTRY, findPropertyById, objectiveToTarget };
